import React, { useState } from "react";
import Chevron from "../../../../assets/customSVG/ChevronCrm";
import WhatsappIcon from "../../../../assets/customSVG/crmWhatsapp";

export const ContactOriginFilters = ({ activeFilter, setActiveFilter }) => {
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(true);

  // Contact origin items from the design


  const contactOriginItems = [
    {
      id: 201,
      label: "Whatsapp",
      name: "WhatsApp",
      icon: () => (
        <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99639 1.38086C5.24462 1.38086 1.37892 5.24728 1.37892 10.0009C1.37617 11.8165 1.95101 13.5859 3.02031 15.0532L1.9464 18.2559L5.25935 17.1971C6.66507 18.1289 8.31492 18.6242 10.0014 18.6208C14.7532 18.6208 18.6189 14.7541 18.6189 10.0009C18.6189 5.24764 14.7536 1.38086 10.0014 1.38086H9.99639ZM7.58998 5.7591C7.42261 5.35899 7.29618 5.3439 7.04297 5.33348C6.94683 5.32739 6.85053 5.32416 6.7542 5.32379C6.42448 5.32379 6.08004 5.42004 5.87245 5.63267C5.61923 5.89127 4.99105 6.49395 4.99105 7.73056C4.99105 8.96717 5.89256 10.1632 6.01432 10.3306C6.1411 10.4976 7.77244 13.0717 10.3053 14.1208C12.2861 14.9419 12.874 14.8658 13.3248 14.7695C13.9835 14.6276 14.8092 14.141 15.0168 13.5534C15.2248 12.9654 15.2248 12.4637 15.1641 12.3573C15.103 12.251 14.9356 12.1903 14.6828 12.0635C14.4292 11.9368 13.198 11.3287 12.9649 11.2475C12.7372 11.1613 12.5195 11.1918 12.3471 11.435C12.104 11.7748 11.8659 12.1192 11.6733 12.3268C11.5214 12.4892 11.2729 12.5096 11.0653 12.4231C10.7866 12.3067 10.0064 12.033 9.04388 11.1768C8.29897 10.5127 7.79255 9.68694 7.64565 9.4384C7.49839 9.18518 7.63056 9.03828 7.74693 8.90144C7.87372 8.74413 7.99512 8.63279 8.1219 8.48589C8.24833 8.33863 8.31945 8.26284 8.40062 8.0908C8.48682 7.92343 8.42576 7.75103 8.3647 7.62389C8.30436 7.49746 7.79758 6.26085 7.58998 5.75946V5.7591Z" fill="#25D366"/>
        </svg>
        
      )
    },
    {
      id: 202,
      label: "Facebook",
      name: "Facebook",
      icon: () => (
        <svg width="23" height="23" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="9" fill="#0082FB"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3248 7.54648H9.58106V6.38398C9.58106 6.22983 9.64229 6.08198 9.7513 5.97298C9.8603 5.86397 10.0081 5.80273 10.1623 5.80273H10.7436V4.34961H9.58106C9.11858 4.34961 8.67505 4.53333 8.34804 4.86034C8.02102 5.18736 7.8373 5.63089 7.8373 6.09336V7.54648H6.6748V8.99961H7.8373V13.6496H9.58106V8.99961H10.7436L11.3248 7.54648Z" fill="white"/>
        </svg>
      )
    },
    {
      id: 203,
      label: "Instagram",
      name: "Instagram",
      icon: () => (
        <div className="flex items-center justify-center">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <rect width="24" height="24" rx="6" fill="url(#instagram_gradient)"/>
            <path d="M17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5Z" fill="white"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" fill="white"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M7.5 3C5.01472 3 3 5.01472 3 7.5V16.5C3 18.9853 5.01472 21 7.5 21H16.5C18.9853 21 21 18.9853 21 16.5V7.5C21 5.01472 18.9853 3 16.5 3H7.5ZM5 7.5C5 6.11929 6.11929 5 7.5 5H16.5C17.8807 5 19 6.11929 19 7.5V16.5C19 17.8807 17.8807 19 16.5 19H7.5C6.11929 19 5 17.8807 5 16.5V7.5Z" fill="white"/>
            <defs>
              <linearGradient id="instagram_gradient" x1="12" y1="0" x2="12" y2="24" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFDD55"/>
                <stop offset="0.5" stopColor="#FF543E"/>
                <stop offset="1" stopColor="#C837AB"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
      )
    },
    {
      id: 204,
      label: "Others",
      name: "Other",
      icon: () => (
        <div className="flex items-center justify-center">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 10C18 5.58172 14.4182 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4182 5.58172 18 10 18C14.4182 18 18 14.4182 18 10Z" stroke="#616874" stroke-width="1.67"/>
            <path d="M10.0076 10H10.0151M14.0151 10H14.0226M6 10H6.00748" stroke="#616874" stroke-width="2.67" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      )
    }
  ];
  

  return (
    <div className="mb-2">
      <div
        className="flex justify-between items-center px-4 py-3 cursor-pointer"
        onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
      >
        <p className="font14px-600 text-gray-800 mt-1 ">Contact Origin</p>
        <span
          className={`transition-transform duration-300 ${
            isFilterDropdownOpen ? "transform rotate-180" : ""
          }`}
        >
          <Chevron />
        </span>
      </div>

      <div
        className={`transition-all duration-200 overflow-hidden ${
          isFilterDropdownOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        {contactOriginItems.map((item) => (
          <div 
            key={item.id}
            className={`flex items-center gap-3 mx-4 px-3 py-2 rounded-md cursor-pointer ${
              activeFilter.label === item.label ? "sidebar-sub-header-active" : "sidebar-sub-header hover:bg-slate-100"
            }`}
            onClick={() => {
              setActiveFilter(item)
            }}
          >
            {item.icon()}
            <p className={`${activeFilter.label === item.label ? "text-green-700 font14px-500" : "font14px-400 text-gray-700"}`}>
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
